import React, { MouseEvent, useState } from 'react';
import { ToastContent, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
import { changePassword } from 'services/coversationService';
import { eyeIcon, CloseEyeIcon } from '../../assets/icons';
import { useDispatch } from 'react-redux';
import { handleLoader } from 'redux/counterSlice';
import { handleActive } from 'redux/persistentSlice';

const ChangePassword = () => {
    const [formValue, setFormValue] = useState({
        email: localStorage.getItem("username"),
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
    });
    const [showPassword, setShowPassword] = useState(false);
    const [showCnfPassword, setShowCnfPassword] = useState(false);
    const [showOldPassword, setShowOldPassword] = useState(false);
    const [errors, setErrors] = useState<any>({});
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const passRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/

    // useEffect(() => {
    //     (ShowChangePassword !== true || ShowChangePassword !== undefined ) && navigate("/chat-bot") 

    // })

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFormValue({ ...formValue, [e.target.name]: e.target.value });
    };
    const handleGoBack = () => {
        if (window.history.length > 1) {
            window.history.back();
        } else {
            navigate('/home'); // Fallback to home page if there's no history
            dispatch(handleActive("qmate"));
        }
    };

    const handleValidation = (formValue: { [s: string]: any }) => {
        const errors: { [s: string]: any } = {};
        if (!formValue.oldPassword) {
            errors.oldPassword = 'Old password is required';
        }
        if (!formValue.newPassword) {
            errors.newPassword = 'New password is required';
        }
        if (!formValue.confirmPassword) {
            errors.confirmPassword = 'Confirm Password is required';
        }
        if (formValue.newPassword && formValue.newPassword === formValue.oldPassword) {
            errors.newPassword = 'The new password must be different from the old password';
        }
        if (formValue.newPassword && !passRegex.test(formValue.newPassword)) {
            errors.newPassword = 'Password must be of minimum eight characters, at least one uppercase letter, one lowercase letter, one number and one special character';
        }
        if (formValue.confirmPassword !== formValue.newPassword) {
            errors.confirmPassword = 'Confirm Password does not match with the new password';
        }
        return errors;
    }

    const handleChangePassword = async (e: MouseEvent<HTMLSpanElement, globalThis.MouseEvent>) => {
        e.preventDefault();
        // Perform validation
        const validationErrors = handleValidation(formValue);

        if (Object.keys(validationErrors).length === 0) {
            dispatch(handleLoader(true));
            try {
                const { result, error } = await changePassword(formValue);
                if (error) {
                    throw error
                }
                if (result?.error) {
                    throw result.error
                }
                dispatch(handleLoader(false));
                toast.success(result.message, {
                    style: {
                        backgroundColor: '#F1F1F1', // Grey background
                    }
                })
                setTimeout(() => {
                    handleGoBack()
                }, 1500)
            } catch (error) {
                toast.error(error as ToastContent<unknown>, {
                    style: {
                        backgroundColor: '#F1F1F1', // Grey background
                    }
                })
                dispatch(handleLoader(false));
            }
        } else {
            dispatch(handleLoader(false));
            // Form is invalid; display validation errors
            setErrors(validationErrors);
        }
    }

    return (
        <main className="content-wrapper p-4">
            <div className='change-password-wrap user-management-section'>
                <h4 className='mb-4'>Change Password</h4>
                <div className="change-password-form">
                    <form>
                        <div className="form-row">
                            <div className="form-col">
                                <label htmlFor="currentPassword" className="form-label">Current Password <span className="text-red-600">*</span></label>
                                <div className='password position-relative'>
                                    <input type={showOldPassword ? "text" : "password"} className="p-inputtext p-component" id="currentPassword" name="oldPassword" aria-describedby="emailHelp" placeholder="Enter current password"
                                        value={formValue.oldPassword}
                                        onChange={(e) => {
                                            delete errors.oldPassword;
                                            handleChange(e);
                                        }} />
                                    <span className={`password-toggle position-absolute top-50 end-0 w-auto translate-middle`} onClick={() => setShowOldPassword(!showOldPassword)}>
                                        {showOldPassword ? <img id='eyeicon' src={eyeIcon} alt="eye-icon" /> :
                                            <img id='close-eye-icon' src={CloseEyeIcon} alt="close-eye-icon" />
                                        }
                                    </span>
                                </div>
                                {errors.oldPassword && <span id="emailHelp" className="mt-2 text-danger">{errors.oldPassword}</span>}
                            </div>
                        </div>
                        {/* <div  className="form-text">We'll never share your email with anyone else.</div> */}
                        <div className="form-row">
                            <div className="form-col">
                                <label htmlFor="exampleInputPassword2" className="form-label">New Password <span className="text-red-600">*</span></label>
                                <div className='password position-relative'>
                                    <input
                                        type={showPassword ? "text" : "password"}
                                        className="p-inputtext p-component"
                                        id="exampleInputPassword2"
                                        name="newPassword"
                                        placeholder="Enter new password"
                                        required
                                        value={formValue.newPassword}
                                        onChange={(e) => {
                                            delete errors.newPassword;
                                            handleChange(e);
                                        }}
                                    />
                                    <span className={`password-toggle position-absolute top-50 end-0 w-auto translate-middle`} onClick={() => setShowPassword(!showPassword)}>
                                        {showPassword ? <img id='eyeicon' src={eyeIcon} alt="eye-icon" /> :
                                            <img id='close-eye-icon' src={CloseEyeIcon} alt="close-eye-icon" />
                                        }
                                    </span>
                                </div>
                                {errors.newPassword && <span className="mt-2 text-danger">{errors.newPassword}</span>}
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="form-col">
                                <label htmlFor="exampleInputPassword1" className="form-label">Confirm Password <span className="text-red-600">*</span></label>
                                <div className='password position-relative'>
                                    <input type={showCnfPassword ? "text" : "password"}
                                        className="p-inputtext p-component"
                                        id="exampleInputPassword1"
                                        placeholder="Confirm password"
                                        name='confirmPassword'
                                        required
                                        value={formValue.confirmPassword}
                                        onChange={(e) => {
                                            delete errors.confirmPassword;
                                            handleChange(e);
                                        }}
                                    />
                                    <span className={`password-toggle position-absolute top-50 end-0 w-auto translate-middle`} onClick={() => setShowCnfPassword(!showCnfPassword)}>
                                        {showCnfPassword ? <img id='eyeicon' src={eyeIcon} alt="eye-icon" /> :
                                            <img id='close-eye-icon' src={CloseEyeIcon} alt="close-eye-icon" />
                                        }
                                    </span>
                                </div>
                                {errors.confirmPassword && <span className="mt-2 text-danger">{errors.confirmPassword}</span>}
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="form-col">
                                {/* text-end */}
                                <button type="submit" onClick={handleChangePassword} className='outline-active-btn'>Submit</button>
                            </div>
                        </div>
                        {/* <div className="mb-3 form-check">
                                    <input type="checkbox" className="form-check-input" id="exampleCheck1" />
                                    <label className="form-check-label" htmlFor="exampleCheck1">Check me out</label>
                                </div> */}
                    </form>
                </div>
            </div>
        </main>
    )
}

export default ChangePassword